<div #deviceSelection>
  <h5>Please select a device to login with:</h5>
  <ul>
    <li class="device" *ngFor="let device of devices" (click)="onDeviceSelected(device)">{{ device.typeName }}</li>
  </ul>
</div>
